import { useUiLocale } from '@/contexts/UiLocaleContext'
import { cn } from '@/lib/utils'

export function BookLanguageSwitcher() {
  const { locale, setLocale, t } = useUiLocale()

  return (
    <div
      className="flex items-center gap-0.5 rounded-full border border-[#ECE3D0] bg-white/95 p-0.5 shadow-sm"
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        onClick={() => setLocale('en')}
        className={cn(
          'rounded-full px-2 py-1 text-[10px] font-bold transition-colors',
          locale === 'en' ? 'bg-[#1F1611] text-white' : 'text-[#8B7E6E] hover:text-[#1F1611]',
        )}
        aria-pressed={locale === 'en'}
        title={t('common.english')}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLocale('ar')}
        className={cn(
          'rounded-full px-2 py-1 text-[10px] font-bold transition-colors',
          locale === 'ar' ? 'bg-[#1F1611] text-white' : 'text-[#8B7E6E] hover:text-[#1F1611]',
        )}
        aria-pressed={locale === 'ar'}
        title={t('common.arabic')}
      >
        AR
      </button>
    </div>
  )
}
